import { Space, Typography } from "antd"
import SmallProfileCard from "../../../components/ContactInfo/SmallProfileCard"
import MasterComponent from "../../../components/Forms"
import { constants } from "../../../constants/common"
import { MasterConfigs } from "../../../interfaces/entity"
import { formatPriceIndian, numberToWordsInIndianFormat } from "../../../constants/functions"
import moment from "moment"
const { Text } = Typography

const SalaryManagement = () => {
    const config: MasterConfigs = {
        api: () => '/salary-management',
        isActionTab: true,
        getFilterColumns: () => [
            {
                label: 'Effective From',
                name: 'effective_from',
                type: 'date',
            }
        ],
        getFormColumns: () => [
            {
                label: 'Employee',
                name: 'employee',
                type: 'select',
                filterFiled: true,
                isCombo: true
            },
            {
                label: 'Salary Structure',
                name: 'salary_structure',
                type: 'select',
                isCombo: true
            },
            { span: 8 },
            {
                label: 'Effective From',
                name: 'effective_from',
                type: 'date',
            },
            {
                label: 'Effective To',
                name: 'effective_to',
                type: 'date',
            },
            {
                label: 'Offered CTC',
                name: 'offered_ctc',
                type: 'text',
            },
            {
                label: 'PF Applicable',
                name: 'is_pf_applicable',
                type: 'checkbox',
            },
            {
                label: 'ESI Applicable',
                name: 'is_esi_applicable',
                type: 'checkbox',
            },
            {
                label: 'PT Applicable',
                name: 'is_pt_applicable',
                type: 'checkbox',
            },
            {
                label: 'LWF Applicable',
                name: 'is_lwf_applicable',
                type: 'checkbox',
            },
            {
                label: 'TDS Applicable',
                name: 'is_tds_applicable',
                type: 'checkbox',
            },
            {
                label: 'Reason',
                name: 'reason',
                type: 'textarea',
                span: 16
            }
        ],
        getColumns: () => [
            {
                title: 'Employee',
                dataIndex: 'employee',
                width: 200,
                fixed: 'left',
                render: (_, record) => <SmallProfileCard
                    name={constants.GET_FULL_NAME(_)}
                    avatar={_?.avatar}
                    subTitle={_?.employeeId}
                />
            },
            {
                title: 'Salary Structure',
                dataIndex: 'salary_structure',
                align: 'center',
                width: 150,
                render: (_) => _?.name
            },
            {
                title: 'Effective From',
                dataIndex: 'effective_from',
                align: 'center',
                width: 150,
                render: (_) => moment(_).format('ddd, DD MMM YYYY')
            },
            {
                title: 'Effective To',
                dataIndex: 'effective_to',
                align: 'center',
                width: 150,
                render: (_) => _ ? moment(_).format('ddd, DD MMM YYYY') : 'Current'
            },
            {
                title: 'Old CTC',
                dataIndex: 'previous_offered_ctc',
                align: 'center',
                width: 150,
                render: (_) => {
                    return <Space direction="vertical">
                        <Text className="font-bold">{_ ? '₹ ' + formatPriceIndian(_) : _}</Text>
                    </Space>
                }
            },
            {
                title: 'Offered CTC',
                dataIndex: 'offered_ctc',
                align: 'center',
                width: 150,
                render: (_) => {
                    return <Space direction="vertical">
                        <Text className="font-bold">₹ {formatPriceIndian(_)}</Text>
                    </Space>
                }
            },
            {
                title: 'Changes',
                dataIndex: 'percentage_change',
                align: 'center',
                width: 150,
                render: (_) => {
                    return <Space direction="vertical">
                        <Text className="font-bold">{_ ? _ + '%' : _}</Text>
                    </Space>
                }
            },
            {
                title: 'Reason',
                dataIndex: 'reason',
                width: 300,
                ellipsis: true
            },
            {
                title: 'Added By',
                dataIndex: 'addedBy',
                width: 180,
                render: (_, record) => _ ? <SmallProfileCard
                    name={constants.GET_FULL_NAME(_)}
                    avatar={_?.avatar}
                    subTitle={_?.employeeId}
                /> : ''
            },
            {
                title: 'Updated By',
                dataIndex: 'updatedBy',
                width: 180,
                render: (_, record) => _ ? <SmallProfileCard
                    name={constants.GET_FULL_NAME(_)}
                    avatar={_?.avatar}
                    subTitle={_?.employeeId}
                /> : ''
            },
            {
                title: 'Created At',
                dataIndex: 'createdAt',
                align: 'center',
                width: 200,
                render: (_) => moment(_).format('lll')
            },
            {
                title: 'Updated At',
                dataIndex: 'updatedAt',
                align: 'center',
                width: 200,
                render: (_) => moment(_).format('lll')
            },
        ],
        combo: [
            {
                name: 'employee',
                api: '/users',
                render: (e) => constants.GET_FULL_NAME(e),
                idKey: '_id'
            },
            {
                name: 'salary_structure',
                api: '/salary-structure-type',
                render: (e) => e.name,
                idKey: '_id'
            }
        ],
        actions: [{ name: 'Add', actionType: "Add" },
        { name: 'filter', actionType: 'filter' }
        ]
    }

    return <>
        <MasterComponent config={config} />
    </>
}

export default SalaryManagement 